import React, { useCallback, useEffect, useRef, useState } from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import styled from 'styled-components';
import {
  faSearch
} from '@fortawesome/pro-light-svg-icons';

const fields = ['geometry.location'];

const dropDownStyle = {
  position:'absolute',
  zIndex: 1,
  minWidth: 'max-content',
};

export default function AddressInput({ value, onChange, onLatLng, ...props }) {
  const setValue = useCallback(newValue => {
    if(onChange) {
      onChange({ target: { value: newValue } });
    }
  }, [onChange]);
  const handleChange = useCallback(newValue => {
    setValue(newValue);
  }, [setValue]);
  const map = useRef();
  const [places, setPlaces] = useState();
  const [sessionToken, setSessionToken] = useState(null);
  useEffect(() => {
    setPlaces(new window.google.maps.places.PlacesService(map.current));
    setSessionToken(new window.google.maps.places.AutocompleteSessionToken());
  }, [map.current]);

  const handleSelect = useCallback(async (address, placeId) => {
    const token = sessionToken;
    setSessionToken(new window.google.maps.places.AutocompleteSessionToken());
    setValue(address);
    if (onLatLng) {
      void places.getDetails({ placeId, fields, sessionToken: token ?? undefined }, (place, status) => {
        if (status == window.google.maps.places.PlacesServiceStatus.OK) {
          const { location } = place.geometry;
          onLatLng({
            address,
            longitude: location.lng(),
            latitude: location.lat(),
          });
        }
      });
    }
  }, [setValue, places, onLatLng, sessionToken]);

  return (<>
    <HiddenMap
      ref={map}
    />
    <PlacesAutocomplete
      {...props}
      {...{ value }}
      onChange={handleChange}
      onSelect={handleSelect}
      debounce={300}
      searchOptions={sessionToken ? { sessionToken } : {}}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div style={{position: 'relative'}}>
          <TextField
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FontAwesomeIcon icon={faSearch} />
                </InputAdornment>
              ),
            }}
            {...getInputProps({
              placeholder: 'Search Places ...',
              className: 'location-search-input',
            })}
          />
          <div className="autocomplete-dropdown-container" style={dropDownStyle}>
            {loading && <div>Loading...</div>}
            {suggestions.map(suggestion => {
              const className = suggestion.active
                ? 'suggestion-item--active'
                : 'suggestion-item';
              // inline style for demonstration purpose
              const style = suggestion.active
                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                : { backgroundColor: '#ffffff', cursor: 'pointer' };
              return (
                <div
                  {...getSuggestionItemProps(suggestion, {
                    className,
                    style,
                  })}
                >
                  <span>{suggestion.description}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  </>);
}

const HiddenMap = styled.div`
  display: none;
  width: 0;
  height: 0;
`;